<div class="panel-preset-selector" [class.compact]="compact">
  <div class="preset-header">
    <nz-icon nzType="layout" nzTheme="outline"></nz-icon>
    <span class="preset-title">{{ 'builderScreen.presets.quickView' |translateTA }}</span>
    <!-- Debug buttons (remove in production) -->
    <div *ngIf="!compact" style="margin-left: auto; display: flex; gap: 4px;">
      <button nz-button nzType="text" nzSize="small" (click)="debugCurrentState()">🐛</button>
      <button nz-button nzType="text" nzSize="small" (click)="testPresetDirect('minimal')" title="Test Minimal">M</button>
      <button nz-button nzType="text" nzSize="small" (click)="testPresetDirect('standard')" title="Test Standard">S</button>
      <button nz-button nzType="text" nzSize="small" (click)="testPresetDirect('advanced')" title="Test Advanced">A</button>
    </div>
  </div>

  <!-- Modern Card-Style Grid Layout -->
  <div class="preset-cards-grid">
    <button
      *ngFor="let preset of presets"
      class="preset-card preset-button"
      [class.selected]="activePreset === preset.id"
      (click)="onPresetSelect(preset.id, $event)"
      [attr.data-preset]="preset.id"
      [title]="preset.name |translateTA"
      type="button">
      
      <!-- Card Icon -->
      <div class="card-icon">
        <nz-icon [nzType]="getPresetIcon(preset.id)" nzTheme="outline"></nz-icon>
      </div>
      
      <!-- Card Label -->
      <div class="card-label" *ngIf="!compact">
        <span>{{ preset.name |translateTA }}</span>
      </div>
      
      <!-- Selection Indicator -->
      <div class="selection-indicator" *ngIf="activePreset === preset.id">
        <nz-icon nzType="check-circle" nzTheme="fill"></nz-icon>
      </div>
    </button>
  </div>

  <!-- Active Preset Info -->
  <div class="active-preset-info" *ngIf="!compact && activePreset">
    <div class="info-content">
      <nz-icon nzType="info-circle" nzTheme="outline"></nz-icon>
      <span>{{ 'builderScreen.presets.activePreset' |translateTA }}: </span>
      <strong>{{ getActivePresetName() |translateTA }}</strong>
    </div>
  </div>
</div>
